// extracted by mini-css-extract-plugin
export default {"link-pid-modal":"LinkPidModal_link-pid-modal__UQZtq"};